export var ETag = /*#__PURE__*/function (ETag) {
  ETag["A"] = "a";
  ETag["Div"] = "div";
  return ETag;
}({});